module.exports = __webpack_public_path__ + "static/media/support5.75edb87b.png";